<script setup lang="ts">
import { ref } from "vue";
import type LxcError from "~/core/models/LxcError.class";
import { PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE } from "~/modules/superAdministration/constants";

const props = defineProps<{
  isTagsLoading: boolean;
  tagsError?: LxcError | null;
  tags?: string[] | null;
  showSelfSignedCertificateForm: boolean;
  showCsrForm: boolean;
}>();

const emit = defineEmits([
  "update:showSelfSignedCertificateForm",
  "update:showCsrForm",
]);

const _showSelfSignedCertificateForm = computed({
  get() {
    return props.showSelfSignedCertificateForm;
  },
  set() {
    emit("update:showSelfSignedCertificateForm");
  },
});

const _showCsrForm = computed({
  get() {
    return props.showCsrForm;
  },
  set() {
    emit("update:showCsrForm");
  },
});

const keystoreListRef = ref();

function refreshKeystoreList() {
  keystoreListRef.value?.search();
}
</script>

<template>
  <keystore-list
    ref="keystoreListRef"
    :is-tags-loading="isTagsLoading"
    :tags-error="tagsError"
    :tags="tags"
    :path-context="PATH_SUPER_ADMINISTRATION_SETTINGS_KEYSTORE"
  />
  <keystore-self-signed-certificate-generation-form
    v-model:side-canvas-shown="_showSelfSignedCertificateForm"
    :is-tags-loading="isTagsLoading"
    :tags-error="tagsError"
    :tags="tags"
    @save="refreshKeystoreList"
  />
  <keystore-csr-generation-form
    v-model:side-canvas-shown="_showCsrForm"
    :is-tags-loading="isTagsLoading"
    :tags-error="tagsError"
    :tags="tags"
    @save="refreshKeystoreList"
  />
</template>
